(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'fr';
    var threshold = parseInt(root.dataset.threshold || '0', 10);
    var msgBelow = root.dataset.msgBelow || '';
    var msgReached = root.dataset.msgReached || '';

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }
    function setText(selector, value) {
      root.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
    }
    function updateProgress(total) {
      if (!threshold) return;
      var bar = root.querySelector('[data-fs-bar]');
      var msg = root.querySelector('[data-fs-msg]');
      var pct = Math.min(100, total / threshold * 100);
      if (bar) bar.style.width = pct + '%';
      if (msg) {
        var remaining = Math.max(0, threshold - total);
        msg.textContent = remaining > 0 ? msgBelow.replace('{{ remaining }}', money(remaining)) : msgReached;
      }
    }
    function render(cart) {
      if (cart.item_count === 0) { window.location.reload(); return; }
      setText('[data-cart-subtotal]', money(cart.total_price));
      setText('[data-cart-count]', cart.item_count);
      updateProgress(cart.total_price);
      root.querySelectorAll('[data-cart-item]').forEach(function (row) {
        var item = (cart.items || []).filter(function (i) { return i.key === row.dataset.lineKey; })[0];
        if (!item) { row.remove(); return; }
        var input = row.querySelector('[data-qty-input]');
        if (input) input.value = item.quantity;
        var price = row.querySelector('[data-line-price]');
        if (price) price.textContent = money(item.final_line_price);
        row.classList.remove('is-loading');
      });
    }
    function change(key, quantity, row) {
      if (row) row.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); })
        .catch(function () { window.location.reload(); });
    }

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-remove]');
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (remove) {
        e.preventDefault();
        var r = remove.closest('[data-cart-item]');
        change(r.dataset.lineKey, 0, r);
      } else if (minus || plus) {
        e.preventDefault();
        var row = (minus || plus).closest('[data-cart-item]');
        var input = row.querySelector('[data-qty-input]');
        var v = parseInt(input.value, 10) || 1;
        v = plus ? v + 1 : Math.max(0, v - 1);
        change(row.dataset.lineKey, v, row);
      }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var row = input.closest('[data-cart-item]');
      var v = Math.max(0, parseInt(input.value, 10) || 0);
      change(row.dataset.lineKey, v, row);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 699px)');
    function apply() {
      document.querySelectorAll('[data-footer-accordion]').forEach(function (d) {
        d.open = !mq.matches;
      });
    }
    apply();
    if (mq.addEventListener) { mq.addEventListener('change', apply); }
    else if (mq.addListener) { mq.addListener(apply); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var burger = header.querySelector('[data-menu-toggle]');
    var closeBtn = header.querySelector('[data-menu-close]');
    var menu = header.querySelector('.header__menu');

    function openMenu() {
      header.classList.add('is-menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('header-menu-open');
    }
    function closeMenu() {
      header.classList.remove('is-menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('header-menu-open');
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (header.classList.contains('is-menu-open')) { closeMenu(); } else { openMenu(); }
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    if (menu) {
      menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeMenu();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1000) closeMenu();
    });

    // ===== Menus déroulants (panneaux) =====
    var panels = header.querySelectorAll('[data-dropdown-panel]');
    var panelByKey = {};
    panels.forEach(function (p) { panelByKey[p.getAttribute('data-dropdown-panel')] = p; });

    // Transforme en déclencheur tout lien du menu dont la clé correspond à un panneau
    var triggers = [];
    header.querySelectorAll('[data-nav-key]').forEach(function (a) {
      var key = a.getAttribute('data-nav-key');
      if (!panelByKey[key]) return;
      a.classList.add('is-dropdown-trigger');
      a.setAttribute('role', 'button');
      a.setAttribute('aria-haspopup', 'true');
      a.setAttribute('aria-expanded', 'false');
      a.setAttribute('data-target', key);
      triggers.push(a);
      a.addEventListener('click', function (event) {
        event.preventDefault();
        openDropdown(key);
      });
    });

    function closeDropdowns() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    function openDropdown(key) {
      var target = panelByKey[key];
      if (!target) return;
      var already = target.classList.contains('is-open');
      closeDropdowns();
      if (!already) {
        target.classList.add('is-open');
        triggers.forEach(function (t) { if (t.getAttribute('data-target') === key) t.setAttribute('aria-expanded', 'true'); });
      }
    }

    header.querySelectorAll('[data-dropdown-close]').forEach(function (b) {
      b.addEventListener('click', function (event) { event.preventDefault(); closeDropdowns(); });
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('.is-dropdown-trigger') || event.target.closest('[data-dropdown-panel]')) return;
      if (window.innerWidth > 1000) closeDropdowns();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDropdowns();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-accordion[data-accordion-exclusive]').forEach(function (root) {
    var rows = root.querySelectorAll('details.accordion-row');
    rows.forEach(function (row) {
      row.addEventListener('toggle', function () {
        if (!row.open) return;
        rows.forEach(function (other) { if (other !== row) other.open = false; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      var idInput = root.querySelector('[data-product-id-input]');
      var mainImg = root.querySelector('[data-product-main-image]');

      function setText(selector, value) {
        root.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
      }
      function setMainImage(src) {
        if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; }
      }

      function selectVariant(sw) {
        root.querySelectorAll('[data-motif-swatch]').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-pressed', 'false');
        });
        sw.classList.add('is-selected');
        sw.setAttribute('aria-pressed', 'true');

        if (idInput) idInput.value = sw.dataset.variantId;
        setText('[data-product-price]', sw.dataset.price);
        setText('[data-current-collection]', sw.dataset.collectionName);
        setMainImage(sw.dataset.image);

        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', sw.dataset.variantId);
          window.history.replaceState({}, '', url);
        } catch (e) {}

        root.querySelectorAll('[data-shape-link]').forEach(function (a) {
          if (a.dataset.shapeUrl) {
            a.href = a.dataset.shapeUrl + '?motif=' + encodeURIComponent(sw.dataset.motif || '');
          }
        });
      }

      function selectCollection(id) {
        var first = null;
        root.querySelectorAll('[data-collection-card]').forEach(function (c) {
          var on = c.dataset.collectionCard === id;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-collection-group]').forEach(function (g) {
          var on = g.dataset.collectionGroup === id;
          g.hidden = !on;
          if (on && !first) first = g.querySelector('[data-motif-swatch]');
        });
        if (first) selectVariant(first);
      }

      root.querySelectorAll('[data-collection-card]').forEach(function (c) {
        c.addEventListener('click', function () { selectCollection(c.dataset.collectionCard); });
      });
      root.querySelectorAll('[data-motif-swatch]').forEach(function (s) {
        s.addEventListener('click', function () { selectVariant(s); });
      });
      root.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { setMainImage(t.dataset.image); });
      });

      var qty = root.querySelector('[data-qty-input]');
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (qty && minus) minus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1; if (v > 1) qty.value = v - 1;
      });
      if (qty && plus) plus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1; qty.value = v + 1;
      });

      try {
        var motif = new URL(window.location).searchParams.get('motif');
        if (motif) {
          var escaped = (window.CSS && CSS.escape) ? CSS.escape(motif) : motif;
          var target = root.querySelector('[data-motif-swatch][data-motif="' + escaped + '"]');
          if (target) { selectCollection(target.dataset.collectionId); selectVariant(target); }
        }
      } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
